/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function WifiIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="wifi"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M2.101 9.101A14 14 0 0 1 21.899 9.101" data-tinysvg-shape="arc" data-tinysvg-arc="12 19 14 14 225 315 0 center" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M5.227 12.227A9.579 9.579 0 0 1 18.773 12.227" data-tinysvg-shape="arc" data-tinysvg-arc="12 19 9.579 9.579 225 -45 0 center" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M8.353 15.353A5.158 5.158 0 0 1 15.647 15.353" data-tinysvg-shape="arc" data-tinysvg-arc="12 19 5.158 5.158 225 -45 0 center" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12 19L12 19" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(166.667)} data-tinysvg-stroke-width="166.667" />
    </svg>
  )
}
